import { Suspense, lazy, useEffect, useState } from "react";
import { Accordion, Badge, Button, Card, Col, Dropdown, Modal, Table } from "react-bootstrap"
import AddExamRules from "./AddExamRules";
import { GetAllExamRules, deleteExamRules } from "../../../../services/CommonService";
import EventBus from "../../../../services/EventBus";
import Pagination from "react-js-pagination";
import { ToastContainer, toast } from "react-toastify";

function ExamRules() {

    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const [postModal, setPostModal] = useState(false);
    const [activePage, setActivePage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0)
    const [updatedata, setUpdateData] = useState({});
    const [examRules, setExamRules] = useState([])
    const svg1 = (
        <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="24" height="24"></rect>
                <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                <circle fill="#000000" cx="19" cy="12" r="2"></circle>
            </g>
        </svg>
    );

    const [subadminbar, setSubAdminbar] = useState(true);

    useEffect(() => {
        getExamRules()

        EventBus.on("loadpagedata", (data) => {
            let obj = {
                payload: {
                    "pageNo": data?.message?.page,
                    "size": 10
                }
            }
            loadData(data?.message?.page);
            //dispatch(fetchAllPaitentsForMedicalBoard({obj:obj}));
        });
        EventBus.remove("loadpagedata");

        const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
        if (constuserdetails?.roles[0] == 'ROLE_SUBADMIN') {
            setSubAdminbar(false)
        }
    }, [])

    const handlePageChange = async (pn) => {
        if (pn !== activePage && !isNaN(pn)) {
            loadNextsetofRecords(pn);
        }
    };
    const loadNextsetofRecords = async (pn) => {
        setActivePage(pn);
        EventBus.dispatch("loadpagedata", {
            message: {
                "page": pn
            }

        });
    };

    const loadData = async (pn) => {

        const reqparams = {
            pageno: pn
        }
        const respData = await GetAllExamRules(reqparams);
        setExamRules(respData.data.docs)
        setTotalRecords(respData.data.totalDocs);
    }


    const getExamRules = async () => {
        const reqparams = {
            pageno: 1,
            // query: { status: "Active" }
        }
        const ResponseData = await GetAllExamRules(reqparams)
        // console.log("Exam rules data", ResponseData.data.docs);
        setExamRules(ResponseData?.data.docs)
        setTotalRecords(ResponseData.data.totalDocs)
    }

    const addModal = async () => {
        setUpdateData({})
        setPostModal(true)

    }

    const closemodal = async () => {
        getExamRules()
        setPostModal(false);
    }

    const openModal = async (item) => {
        setUpdateData(item);
        setPostModal(true);
    }
    const deleteItem = async (item) => {
        const Response = await deleteExamRules(item);
        // console.log("Delete resp",Response.data);
        if (Response.data?.id) {
            notifyTopFullWidth("Data deleted successfully");
            getExamRules()
        }

    }


    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Card>
                <Card.Header>
                    <Card.Title>Exam Rules <Button onClick={() => addModal()}
                        className="me-2" variant="primary btn-square"
                        title="Add Exam Rules"
                    >
                        <span className="btn-icon-start text-danger">
                            <i className="fa fa-plus color-danger" />
                        </span>
                        ADD
                    </Button></Card.Title>
                </Card.Header>
                <Card.Body>
                    <Table responsive>
                        <thead>
                            <tr>
                                <th className="width80">
                                    <strong>Display Order</strong>
                                </th>
                                <th>
                                    <strong>Rule Name</strong>
                                </th>
                                <th>
                                    <strong>Repeat questions</strong>
                                </th>
                                <th>
                                    <strong>Subjects</strong>
                                </th>

                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {examRules?.map(item => (
                                <tr key={item.id}>
                                    <td>
                                        <strong>{item.position}</strong>
                                    </td>
                                    <td>{item.Rulename}</td>
                                    <td>{item.repeatquestions}</td>

                                    <td>{item.subRules.map((ele)=>{return (ele.Subjectname)})}</td>
                                    <td></td>

                                    <td>
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant="success"
                                                className="light sharp i-false"
                                            >
                                                {svg1}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => openModal(item)}>
                                                    Edit

                                                </Dropdown.Item >
                                             {subadminbar &&   <Dropdown.Item onClick={() => deleteItem(item)}>

                                                    Delete

                                                </Dropdown.Item >}

                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>
                    <div >

                        <Pagination
                            activePage={activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                            activeClass="active"
                            itemClass="page-item"
                            innerClass="pagination mb-0"
                            linkClass="page-link"
                            firstPageText="First"
                            lastPageText="Last"
                            prevPageText="Previous"
                            nextPageText="Next"
                            disabledClass="disabled"
                            activeLinkClass="disabled"
                        />
                    </div>
                </Card.Body>
            </Card>


            <Modal className="modal fade" size="xl" show={postModal} onHide={setPostModal} >
                <div className="" role="document">
                    <div className="">
                        <form >
                            <div className="modal-header">

                                <button type="button" className="btn-close" onClick={closemodal} data-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">


                                <Suspense fallback={<div>Loading</div>}>
                                    <AddExamRules updateprop={updatedata} />
                                </Suspense>


                            </div>

                        </form>

                    </div>
                </div>
            </Modal>

        </>
    )
}

export default ExamRules